import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, useCallback, useEffect, useRef, useState, } from 'react';
import { useReveal } from './reveal.context';
export const RevealTrigger = ({ trigger, activeTrigger, revealId, }) => {
    const triggerRef = useRef(null);
    const [hasBeenClicked, setHasBeenClicked] = useState(false);
    const { activeReveal, setActiveReveal } = useReveal();
    const isActive = activeReveal === revealId;
    const theTrigger = isActive ? activeTrigger : trigger;
    useEffect(() => {
        if (hasBeenClicked && isActive) {
            triggerRef.current.focus();
        }
    }, [activeReveal]);
    const Trigger = useCallback(() => cloneElement(theTrigger, {
        onClick: () => {
            setHasBeenClicked(true);
            setActiveReveal(revealId);
        },
        'aria-controls': `reveal-content-${revealId}`,
        'aria-expanded': isActive,
        id: `reveal-trigger-${revealId}`,
        ref: triggerRef,
    }), [activeReveal]);
    return _jsx(Trigger, {});
};
//# sourceMappingURL=reveal.trigger.js.map